import EventEmitter from 'eventemitter3'

export default class BlockFactory {
	static eventEmitter = new EventEmitter()
	static globalHandlers = {}
	static create(instance, element, loadDependencies = true) {
		// eslint-disable-next-line no-param-reassign
		element.ref = new instance(element, this.eventEmitter)
		if (typeof element.ref.getGlobalHandler === 'function') {
			const [method, callback] = element.ref.getGlobalHandler()
			if (this.globalHandlers[method]) {
				this.globalHandlers[method] = [...this.globalHandlers[method], callback]
			} else {
				this.globalHandlers[method] = [callback]
			}
		}

		Object.keys(this.globalHandlers).map(method => {
			window[method] = () => {
				this.globalHandlers[method].forEach(callback => callback())
			}
		})

		if (loadDependencies && typeof element.ref.getDependency === 'function') {
			const firstScriptTag = document.getElementsByTagName('script')[0]
			const tag = document.createElement('script')
			tag.defer = true
			tag.async = true
			if (typeof element.ref.load === 'function') {
				tag.onload = element.ref.load.bind(element.ref)
			}
			tag.src = element.ref.getDependency()
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
		}
		if (typeof element.ref.init === 'function') {
			element.ref.init()
		}
	}
}

